

// export default App;
import { Suspense, lazy, useEffect, useRef, useState } from "react";
import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import routes from "./Routes";
import Loader from "./CommonComponent/Loader";
import SignIn from "./Auth/Pages/SignIn";
import SignUp from "./Auth/Pages/SignUp";

import NotFound from "./Auth/Pages/NotFound";
import { ref, onValue } from "firebase/database";
import { db } from "./Helper/Firebase";
import Maintenance from "./Layout/Maintenance";
import { useDispatch } from "react-redux";
import { setIsLoading } from "./Redux/Action/ActionSlice";
import { clearOrderData, clearOrderDataReturn } from "./Redux/Transaksi/transaksiSlice";
import RouterWatcher from "./CommonComponent/RouterWatcher";

const MainLayout = lazy(() => import("./Layout/MainLayout"));

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch(); 

  const prevPath = useRef(location.pathname);

  useEffect(() => {
    dispatch(setIsLoading({status:false}));
    setTimeout(() => setLoading(false), 1000);
  }, []);

  useEffect(() => {
      const disableScroll = (e) => {
          if (document.activeElement.type === 'number') {
          e.preventDefault();
          }
      };
      document.addEventListener('wheel', disableScroll, { passive: false });
      return () => {
          document.removeEventListener('wheel', disableScroll);
      };
  }, []);

  useEffect(() => {
    const from = prevPath.current;
    const to = location.pathname;

    if (from === "/transaksi/return/proses") {
      dispatch(clearOrderData());
      dispatch(clearOrderDataReturn());
    }

    prevPath.current = to;
  }, [location.pathname]);

  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    console.log("maintenance check")
    const maintenanceRef = ref(db, "/pos");
    onValue(maintenanceRef, (snapshot) => {
      if (snapshot.exists()) {
        console.log("Snapshot Data:", snapshot);
        setMaintenance(snapshot.val());
      } else {
        console.log("No data found at /pos");
      }
    }, (error) => {
      console.error("Firebase read failed:", error);
    });
  }, []);

  return maintenance ? <Maintenance /> :  loading ? (
    <Loader />
  ) : (
    <>
   
      
        {/* <RouterWatcher/> */}
        <Routes>
          {/* {/* <Route path="/auth/signin" element={<SignIn />} /> */}
          <Route path="*" element={<NotFound />} />
          <Route path="/auth/signin" element={<SignIn />} />
          <Route path="/auth/signup" element={<SignUp />} />
          <Route index element={<SignIn />} />
          <Route element={<MainLayout />}>
            {routes.map((routes, index) => {
              const { path, component: Component } = routes;
              return (
                <Route
                  key={index}
                  path={path}
                  element={
                    <Suspense fallback={<Loader />}>
                      <Component />
                    </Suspense>
                  }
                />
              );
            })}
          </Route>
        </Routes>
      {/* </BrowserRouter> */}
    </>
  );
}

export default App;